import { BulkActionOnAction,
	BulkActionState, BULK_ACTION_TYPES } from "../../../types/bulk"

const initialState: BulkActionState = {
	message: null,
	bulkAction: null
}

export default (state = initialState, action: BulkActionOnAction): BulkActionState => {
	switch (action.type) {
		case BULK_ACTION_TYPES.SET_MESSAGE_WRITING: {
            return {
				...state,
				bulkAction: { ...state.bulkAction,
					data: { ...state.bulkAction?.data, text: action.payload as string } }
			}
        }
		case BULK_ACTION_TYPES.CREATE_BULK_ACTION: {
            return {
				...state,
				bulkAction: action.payload,
			}
        }

		default:
			return state
	}
}
